/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { MultiSelect as MultiSelected } from "react-multi-select-component";
import * as app from "../services/AppService";
import { RowItem } from "../models/Core/row-item";
import { KeyValue } from "../models/Core/key-value";
import { InterfaceComponentsProps } from "../models/Core/componentsCore";

interface Props extends RowItem, Omit<InterfaceComponentsProps, "Icon" | "isTable" |"ID"> {
    model: any;
    options: KeyValue[];
    onChange: (selectedObjectsArray: KeyValue[], selectedKeyArray: string[]) => void
    noLabel?: boolean
}

export default function MultiSelect(props: Props) {
    const [selectedObj, setSelectedObj] = useState<any[]>([]);

    const SelectValues = () => {
        var ArrV = [];
        ArrV = props.options.filter((item) => props.model && props.model.includes(item.Key)).map(item => ({ ...item,label: item.Value, value: item.Key }));
        setSelectedObj(ArrV);
    }

    useEffect(() => {
        SelectValues();
    }, [props.model, props.options])

    const handler = (selectedObjectsArray: KeyValue[]) => {
        setSelectedObj(selectedObjectsArray);
        props.onChange(selectedObjectsArray, selectedObjectsArray.map((i) => i.Key));
    };

    var LablesValues = {
        selectAll: app.translate("SelectAll"),
        search: app.translate("Search"),
        selectSomeItems: app.translate("select"),
        allItemsAreSelected: app.translate("Don") + " " + app.translate("SelectAll")
    };

    return (

        <div className="mt-1">
            {!props.noLabel &&<label className={`${props.labelClass}`}>{app.translate(props.label)}</label>}
            <MultiSelected
                options={props.options.map(item =>({ ...item,label: item.Value, value: item.Key }))}
                value={selectedObj}
                onChange={handler}
                labelledBy="Selectmax"
                className={`shadow-sm rounded h-25 ${props.class}`}
                disabled={props.disabled}
                overrideStrings={LablesValues}
            />
        </div>
    );
};

MultiSelect.defaultProps = {
    class: " ",
    labelClass: "fw-semibold text-primary-emphasis ",
    disabled: false,
}